import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const yesItems = ['Vendés con stock propio en ML (no dropshipping)', 'Facturás entre $200k y $3M ARS por mes', 'No tenés claro tu margen real después de comisiones', 'Querés crecer pero no sabés por dónde empezar', 'Buscás una herramienta simple, no un software costoso'];
const noItems = ['Buscás una solución mágica sin poner trabajo', 'Ya tenés un sistema de gestión profesional funcionando', 'No estás dispuesto a actualizar los datos semanalmente'];
export function WhoIsItFor() {
  return <section className="bg-white py-16 md:py-24" data-id="element-261">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-262">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-263">
          <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl text-navy" data-id="element-264">
            ¿Este Kit es para vos?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-265">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-teal rounded-2xl p-6 md:p-8" data-id="element-266">
            <h3 className="font-display font-bold text-white text-xl mb-6" data-id="element-267">
              SÍ, es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-268">
              {yesItems.map((item, i) => <li key={i} className="flex items-start gap-3 text-white/90 text-sm leading-relaxed" data-id="element-269">
                  <CheckIcon className="w-5 h-5 text-white shrink-0 mt-0.5" data-id="element-270" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-red-500 rounded-2xl p-6 md:p-8" data-id="element-271">
            <h3 className="font-display font-bold text-white text-xl mb-6" data-id="element-272">
              NO es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-273">
              {noItems.map((item, i) => <li key={i} className="flex items-start gap-3 text-white/90 text-sm leading-relaxed" data-id="element-274">
                  <XIcon className="w-5 h-5 text-white shrink-0 mt-0.5" data-id="element-275" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}